import React from "react";
import { Tb3DCubeSphere } from "react-icons/tb";
import { BiSolidColor } from "react-icons/bi";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

import DynamicLineChart from "./realmComponents/DynamicLineChart.js";
import DynamicStringMetricChart from "./realmComponents/DynamicStringMetricChart.js";

const orangeColor = "#c97b06";

const MetricItem = ({
  metric,
  isNumeric,
  isOpen,
  meta,
  setOpenNumericMetric,
  setOpenStringMetric,
  handleMetricClick,
  selectedMetric,
  selectedKey,
  numericSummary,
  keySummary,
  selectedYearEditing,
  selectedRange,
  setSelectedYearEditing,
  availableDates,
  marks,
  toIsoWithOffset,
  longstandingGeoJSONRef,
  polygonCustomLayerRef,
  multuGroupSelectedArray,
  setMultuGroupSelectedArray,
  setGlobalPolygonTransparency,
  numericTimeAggregationMethod,
  scenarioModels = [],
  scenarioModelingActive,
  IsLoadingNewGeoJSONFromAnUpdate
}) => {

  const hasMultiGroupSelection =
    Array.isArray(multuGroupSelectedArray) &&
    multuGroupSelectedArray.length > 0;

  const borderColor = hasMultiGroupSelection
    ? "#2964A8"
    : "#29645D";

  const summarizedFeatureIds = hasMultiGroupSelection
    ? multuGroupSelectedArray
    : (longstandingGeoJSONRef?.current?.features || []).map((feature) => feature.skylark_id);

  const isSelected = isNumeric
    ? metric === selectedMetric
    : metric === selectedKey;
  const isScenarioMetric = ["BD_Parcel", "ParcelCarbon", "HabitatType"].includes(metric);
  const scenarioModelingIsActive = scenarioModelingActive;

  console.log(isScenarioMetric)

  return (
    <div
      style={{
        marginTop: "5px",
        marginBottom: "5px",
        borderTop: `1px solid ${borderColor}`,
        borderRight: `1px solid ${borderColor}`,
        borderBottom: `1px solid ${borderColor}`,
        borderLeft: isScenarioMetric && scenarioModelingIsActive
          ? "4px solid #D63384"
          : `1px solid ${borderColor}`,
        borderRadius: "3px"
      }}
    >

      <button
        onClick={() => {
          if (isNumeric) {
            if (!isOpen) {
              setOpenNumericMetric(metric);
              handleMetricClick?.({
                metric,
                isNumeric: true
              });
            }
          } else {
            if (!isOpen) {
              setOpenStringMetric(metric);
              handleMetricClick?.({
                metric,
                isNumeric: false
              });
            }
          }
        }}
        style={{
          width: "100%",
          paddingLeft: "5px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
        }}
      >

        <span style={{
          display: "flex",
          alignItems: "center",
          gap: "5px"
        }}>

          {meta.name || metric}

          {!isNumeric && isOpen && (
            <span style={{
              fontSize: "10px",
              marginLeft: "5px"
            }}>
              <b>
                {(() => {
                  const date = new Date(selectedYearEditing);
                  const day = String(date.getDate()).padStart(2, "0");
                  const month = String(date.getMonth() + 1).padStart(2, "0");
                  const year = String(date.getFullYear()).slice(-2);

                  return `${day}/${month}/${year}`;
                })()}
              </b>
            </span>
          )}

          {isNumeric && isOpen && (
            <span style={{
              fontSize: "10px",
              marginLeft: "5px"
            }}>
              <b>
                {(() => {
                  const date = new Date(selectedYearEditing);
                  const day = String(date.getDate()).padStart(2, "0");
                  const month = String(date.getMonth() + 1).padStart(2, "0");
                  const year = String(date.getFullYear()).slice(-2);

                  return `${day}/${month}/${year}`;
                })()}
                {" • "}
                {
                  typeof numericSummary?.[metric]?.[selectedYearEditing] === "number"
                    ? numericSummary[metric][selectedYearEditing].toFixed(2)
                    : numericSummary?.[metric]?.[selectedYearEditing] ?? "N/A"
                }
              </b>
            </span>
          )}

        </span>


        <div
          style={{
            color: "#fff",
            fontSize: "14px",
            opacity: isSelected ? 1 : 0.3,
            backgroundColor: borderColor,
            padding: "6px 8px 5px 9px"
          }}
        >
          {
            isNumeric
              ? <Tb3DCubeSphere />
              : <BiSolidColor />
          }
        </div>

      </button>


      {isOpen && (
        <div style={{
          marginTop: "8px",
          marginBottom: "10px",
          padding: "5px",
        }}>

          {isNumeric ? (
            <DynamicLineChart
              value={numericSummary?.[metric] || {}}
              valuePropertyName={meta.name}
              comparisonValue={keySummary?.[metric] || {}}
              unit={metric}
              height={200}
              isEnlarged={true}
              selectedYearEditing={selectedYearEditing}
              selectedRange={selectedRange}
              multuGroupSelectedArray={multuGroupSelectedArray}
              setSelectedYearEditing={setSelectedYearEditing}
              availableDates={availableDates}
              numericTimeAggregationMethod={numericTimeAggregationMethod}
              scenarioModels={scenarioModels}
              summarizedFeatureIds={summarizedFeatureIds}
              applyScenarioModel={metric === "BD_Parcel" || metric === "ParcelCarbon"}
              scenarioImpactField={metric === "BD_Parcel" ? "Biodiversity" : "ParcelCarbon"}
              longstandingGeoJSONRef={longstandingGeoJSONRef}
              IsLoadingNewGeoJSONFromAnUpdate={IsLoadingNewGeoJSONFromAnUpdate}
            />

          ) : (

            <>

              <DynamicStringMetricChart
                metric={metric}
                catgeoryPropertyName={meta.name}
                keySummary={keySummary}
                selectedYearEditing={selectedYearEditing}
                scenarioModels={scenarioModels}
                numericTimeAggregationMethod={numericTimeAggregationMethod}
                summarizedFeatureIds={summarizedFeatureIds}
                applyScenarioModel={metric === "HabitatType"}
                longstandingGeoJSONRef={longstandingGeoJSONRef}
                selectedKey={selectedKey}
                polygonCustomLayerRef={polygonCustomLayerRef}
                multuGroupSelectedArray={multuGroupSelectedArray}
                setMultuGroupSelectedArray={setMultuGroupSelectedArray}
                setGlobalPolygonTransparency={setGlobalPolygonTransparency}
                setSelectedYearEditing={setSelectedYearEditing}
                availableDates={availableDates}
                IsLoadingNewGeoJSONFromAnUpdate={IsLoadingNewGeoJSONFromAnUpdate}
              />

            </>
          )}

        </div>
      )}

    </div>
  );
};


export default MetricItem;
